import { useEffect } from 'react'
import Cookies from 'js-cookie'
import PropTypes from 'prop-types'

const GoogleMarketing = ({ successConversionTracking }) => {
  useEffect(() => {
    const googleMarketing = Cookies.get('googlemarketing')
    if (googleMarketing !== undefined) {
      const trackings = successConversionTracking.filter(tracking => tracking.floodlightConfigID === googleMarketing)
      if (trackings.length !== 0) {
        const {
          floodlightConfigID, activityGroupTagString, activityTagString, countingMethod,
        } = trackings[0]

        const script = document.createElement('script')
        script.src = `https://www.googletagmanager.com/gtag/js?id=DC-${floodlightConfigID}`
        script.async = true
        document.body.appendChild(script)

        window.dataLayer = window.dataLayer || []
        window.gtag = (...args) => {
          window.dataLayer.push(args)
        }
        window.gtag('js', new Date())
        window.gtag('config', `DC-${floodlightConfigID}`)
        window.gtag('event', 'conversion', {
          allow_custom_scripts: true,
          send_to: `DC-${floodlightConfigID}/${activityGroupTagString}/${activityTagString}+${countingMethod}`,
        })
      }
    }
  }, [])
  return null
}

GoogleMarketing.propTypes = {
  successConversionTracking: PropTypes.arrayOf(PropTypes.shape({
    activityGroupTagString: PropTypes.string,
    activityTagString: PropTypes.string,
    countingMethod: PropTypes.string,
    floodlightConfigID: PropTypes.string,
  })),
}

GoogleMarketing.defaultProps = {
  successConversionTracking: [],
}

export default GoogleMarketing



// WEBPACK FOOTER //
// ./components/GoogleMarketing/index.jsx